/**
 * Deterministische Berechnung von Lifecycle-Daten aus dem Seed.
 * Fallback bis die DB destruction_time und fate liefert.
 */

import type { SunFate } from './SunLifecycleTypes';

/**
 * Erzeugt deterministisch eine destruction_time aus dem Seed.
 */
export function seedToDestructionTime(
  seed: number,
  worldCreatedAt: number,
  minDays: number,
  maxDays: number,
): number {
  const hash = Math.abs(Math.sin(seed * 12345.6789 + 0.7)) % 1;
  const days = minDays + hash * (maxDays - minDays);
  return worldCreatedAt + days * 86_400_000;
}

/**
 * Bestimmt deterministisch das Schicksal einer Sonne aus dem Seed.
 */
export function seedToFate(seed: number, blackHoleChance: number): SunFate {
  const hash = Math.abs(Math.sin(seed * 98765.4321 + 0.3)) % 1;
  return hash < blackHoleChance ? 'black_hole' : 'explode';
}
